import dynamic from 'next/dynamic';
import { Fragment, useRef, useState } from 'react';
import { useLocationState } from '../../context/location';
import { submitClientRequest } from '../../helpers/clientRequest';
import Input from '../Input';
import Textarea from '../Textarea';
import Button from '../Button';
import styles from '../../styles/modules/career/CareerVacancy.module.scss';
import FormAgreement from '../FormAgreement';

const Modal = dynamic(() => import('../../components/Modal'));

const CareerVacancy = () => {
  const locationState = useLocationState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientComment, setClientComment] = useState('');
  const [agreeWithPolicy, setAgreeWithPolicy] = useState(false);
  const clientNameId = useRef();
  const clientPhoneId = useRef();

  const handleFormSubmit = () => {
    clientNameId.current.setError(clientName.length <= 3);
    clientPhoneId.current.setError(clientPhone.length !== 11);

    if (clientName.length > 3 && clientPhone.length === 11 && agreeWithPolicy) {
      submitClientRequest({
        clientName,
        clientPhone: clientPhone,
        clientComment,
        pathName: window.location.pathname,
        whatComponent: 'CareerVacancy',
        location: locationState.name,
        platform: 'web',
        recipient: 'personal'
      }).then((isSubmitted) => {
        if (isSubmitted) setIsSubmited(true);
      });
    }
  };

  return (
    <section className={['block', 'big', styles.vacancy].join(' ')}>
      <Modal
        title="Оставить заявку"
        button={!isSubmited && 'Отправить'}
        buttonDisabled={!agreeWithPolicy}
        action={handleFormSubmit}
        visibility={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      >
        {isSubmited ? (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Спасибо за вашу заявку. Мы скоро с Вами свяжемся!
            </div>
            <img
              src="/images/thumbUp.png"
              alt=""
              style={{ padding: 50, width: '100%', boxSizing: 'border-box' }}
            />
          </Fragment>
        ) : (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки!
            </div>
            <Input
              title="Имя"
              inputs={[
                {
                  placeholder: 'Василий Петрович',
                  value: clientName,
                  type: 'text'
                }
              ]}
              isWrappedStyle
              ref={clientNameId}
              onChange={(v) => setClientName(v[0])}
            />
            <Input
              title="Телефон"
              inputs={[
                {
                  placeholder: locationState.phone,
                  value: clientPhone,
                  mask: 'phone',
                  type: 'tel'
                }
              ]}
              isWrappedStyle
              ref={clientPhoneId}
              onChange={(v) => setClientPhone(v[0])}
            />
            <Textarea
              title="Коммментарий"
              placeholder="Например, «Хочу работать у вас, вы меня научите всему?»"
              autoHeight
              isWrappedStyle
              onChange={(v) => setClientComment(v)}
            />
            <FormAgreement onChange={setAgreeWithPolicy} />
          </Fragment>
        )}
      </Modal>
      <div className="fixed">
        <h3>Актуальные вакансии</h3>
        <CareerVacancyItem
          title="Менеджер по продаже недвижимости"
          description="от 120 000 ₽"
          content={
            <Fragment>
              <ul className={styles.vacancyItemData}>
                <li>Корпоративное обучение, охватывающее все аспекты работы.</li>
                <li>Профессиональные коллеги, готовые поделиться своим опытом.</li>
                <li>Полная рекламная поддержка.</li>
                <li>Информационное и юридическое сопровождение.</li>
                <li>Гарантированный быстрый карьерный рост.</li>
                <li>Ежемесячная стипендия агентам-стажерам.</li>
                <li>Высокие комиссионные, начиная с 120 000 ₽.</li>
              </ul>
              <div className={styles.vacancyItemDataCaption}>
                Присоединяйтесь к нашей команде и раскройте свой потенциал в сфере недвижимости!
              </div>
            </Fragment>
          }
          onCallbackClick={() => setIsModalVisible(true)}
        />
        <CareerVacancyItem
          title="Руководитель отдела продаж"
          description="от 110 000 ₽"
          content={
            <Fragment>
              <ul className={styles.vacancyItemData}>
                <li>Формирование высокопрофессиональной команды.</li>
                <li>Эффективное управление отделом продаж.</li>
                <li>Постоянное увеличение объема продаж.</li>
              </ul>
              <div className={styles.vacancyItemDataCaption}>
                Присоединяйтесь к нам, чтобы возглавить успешный отдел продаж и достичь вместе с
                нами новых высот!
              </div>
            </Fragment>
          }
          onCallbackClick={() => setIsModalVisible(true)}
        />
        <CareerVacancyItem
          title="Офис-менеджер"
          description="от 30 000 ₽"
          content={
            <Fragment>
              <ul className={styles.vacancyItemData}>
                <li>Обработка входящей и исходящей корреспонденции.</li>
                <li>Составление, корректировка и ведение договоров аренды.</li>
                <li>Принятие входящих звонков.</li>
                <li>
                  Осуществление учета и контроля за деятельностью персонала (охрана, мастера
                  чистоты, заведующий хозяйством).
                </li>
                <li>Выполнение поручений руководителя.</li>
              </ul>
              <div className={styles.vacancyItemDataCaption}>
                Присоединяйтесь к нашей команде и воплотите свой опыт в эффективное управление
                офисными процессами!
              </div>
            </Fragment>
          }
          onCallbackClick={() => setIsModalVisible(true)}
        />
        <CareerVacancyItem
          title="Менеджер по подбору персонала"
          description="от 60 000 ₽"
          content={
            <Fragment>
              <ul className={styles.vacancyItemData}>
                <li>Размещение и продвижение вакансий на рабочих сайтах и в социальных сетях.</li>
                <li>Поиск кандидатов и оценка резюме.</li>
                <li>Проведение собеседований.</li>
                <li>
                  Адаптация новых сотрудников (контроль испытательного срока, поддержка в период
                  адаптации).
                </li>
                <li>Ведение отчетности.</li>
                <li>Активное участие в корпоративной жизни компании.</li>
              </ul>
              <div className={styles.vacancyItemDataCaption}>
                Присоединяйтесь к нашей команде, где ваши навыки в подборе и адаптации персонала
                будут цениться, а карьерный рост - поддерживаться!
              </div>
            </Fragment>
          }
          onCallbackClick={() => setIsModalVisible(true)}
        />
      </div>
    </section>
  );
};

const CareerVacancyItem = ({ title, description, content, onCallbackClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={styles.vacancyItem}>
      <div className={styles.vacancyItemHead}>
        <div>
          <div className={styles.vacancyItemTitle}>{title}</div>
          <div className={styles.vacancyItemDescription}>
            {description} ⋅{' '}
            <a onClick={() => setIsExpanded((x) => !x)}>
              {isExpanded ? 'Свернуть' : 'Развернуть'} описание
            </a>
          </div>
        </div>
        <Button className={styles.vacancyItemButton} onClick={onCallbackClick}>
          Откликнуться
        </Button>
      </div>
      {isExpanded && <div className={styles.vacancyItemBody}>{content}</div>}
    </div>
  );
};

export default CareerVacancy;
